import styled from "styled-components";

const Input = styled.input`
  border: solid 1px #ccc;
  line-height: 2;
  padding: 5px 10px;
  border-radius: 4px;
  background-color: #fdfdfd;
  width: 100%;
  margin-bottom: 12px;
`;
export default Input;
